// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"66dc6d4fe693a16a","6831":"3892d8ed6021efbf","8503":"d225846929dd668b","9683":"42c420714932b70f"}[chunkId] + ".js";
};